import React, { useState, useImperativeHandle, forwardRef, useEffect  } from 'react';
import { DatePicker } from 'antd';
import { useLanguage } from 'Context/LanguageContext';
import { disabledDate, disabledDateTime } from '../utils';
import Grid from '@mui/material/Grid2';
import { Typography } from '@mui/material';

const { RangePicker } = DatePicker;
const moment = require('moment');
const TaskDates = ({disabled, executionDatesAux}, ref) => {
	const lan = useLanguage();
	const [executionDates, setExecutionDates] = useState(executionDatesAux ? executionDatesAux : []);
	useImperativeHandle(ref, () => executionDates, [executionDates]);
  useEffect(() => {
    if (disabled) setExecutionDates([]);
  }, [disabled]);
	function onChange(value) {
		if (value) {
			const now = moment();

			if (now.isAfter(value[0])) {
				value[0] = moment();
			}

			if (now.isAfter(value[1])) {
				value[1] = moment();
			}

			if (value[1].diff(value[0]) < 60000 && value[0].minutes() === value[1].minutes()) {
				value[1].add(1, 'm');
			}

			setExecutionDates(value);
		} else {
			setExecutionDates([]);
		}
	}
	return (
    <Grid container spacint={1} alignItems='center' sx={{ mb: 2 }}>
      <Grid size={12} sx={{ mb: 1 }}>
        <Typography variant={'body2'}>{`${lan.executionPeriod} (${lan.optional})`}</Typography>
      </Grid>
      <Grid size={12}>
        <RangePicker
          style={{ height: '55px', borderColor: '#C4C4C4', borderRadius: '12px; !important', width: '100%' }}
          size='large'
          showTime={{ format: 'HH:mm' }}
          format='YYYY-MM-DD HH:mm'
          placeholder={[lan.initialDate, lan.finalDate]}
          disabledDate={disabledDate}
          disabledTime={disabledDateTime}
          value={executionDates}
          onChange={onChange}
          disabled={disabled}
        />
      </Grid>
    </Grid>
	);
};
export default forwardRef(TaskDates);
